import { mapEAR } from "./map/mapEAR";
window.addEventListener("DOMContentLoaded", function (event) {
    console.log("JS start");
    var map = new mapEAR();
    map.init();
});
